import React from 'react';
import {
  Box,
  Icon,
  IconName,
  Text,
} from '@usealloy/component-library';
import type { SnippetNode as ISnippetNode, WorkflowNodeProps } from 'flow/service/graph';
import BaseNode from '../BaseNode';
import { StyledLabelText, StyledSnippetIconContainer } from './styles';

function SnippetNode(props: WorkflowNodeProps<ISnippetNode>) {
  const { id, type, data: { children } } = props;
  // Todo:
  // - add in expanded state style
  // - dynamically load in snippet configurations
  // - add fixed "shadow" card behind main card

  const icon = (
    <StyledSnippetIconContainer alignItems="center" justifyContent="center">
      <Icon
        icon={IconName.AddressCard}
        size="large"
        color="var(--cl-gray-000)"
      />
    </StyledSnippetIconContainer>
  );

  const label = (
    <Box direction="column" alignItems="flex-start" width="116px">
      <Text size={1} style={{ color: 'var(--cl-text-muted)' }}>
        {`${children.length} Nodes`}
      </Text>
      <StyledLabelText>
        Snippet Name
      </StyledLabelText>
    </Box>
  );

  return (
    <BaseNode
      id={id}
      icon={icon}
      label={label}
      style={{
        borderRadius: 'var(--cl-radius-3)',
        border: '1px solid var(--cl-juicyBlue-100)',
        height: '48px',
        padding: 'var(--cl-space-1) var(--cl-space-2)',
        boxShadow: '0px 0px var(--cl-space-3) var(--cl-juicyBlue-100)',
      }}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-000)',
        highlighted: {
          backgroundColor: 'var(--cl-gray-000)',
        },
        hovered: {
          backgroundColor: 'var(--cl-gray-100)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(SnippetNode);
